import { defineStore } from 'pinia';
import { decryptPayload } from '../services/application';
import * as logger from '../utils/logger';
import { useJobDataStore } from './job-store';
// eslint-disable-next-line import/no-cycle
import { useGdprTextsStore } from './gdpr-texts-store';
// eslint-disable-next-line import/no-cycle
import { useApplicationStore } from './application-store';

export const usePayloadStore = defineStore('payload', {
    state: () => ({
        jobId: null,
        isChiffre: null,
        jobTitle: null,
        companyName: null,
        jobLink: null,
        exists: false,
        atsUserUuid: null,
        encryptedPayload: null,
    }),
    actions: {
        async decryptPayload(requestData) {
            try {
                const payload = await decryptPayload(requestData.uuid, requestData.payload);
                payload.data.atsUserUuid = requestData.uuid;
                payload.data.encryptedPayload = requestData.payload;

                const { title, href, jobId, companyName, isChiffre } = payload.data;
                const jobData = useJobDataStore();

                // If user uses same tab for a different application, purge cached data
                // Also check for jobId being 0 (e.g. chiffre jobs)
                if (jobId !== jobData.jobId || jobId === 0) {
                    const gdpr = useGdprTextsStore();
                    const application = useApplicationStore();

                    jobData.$reset();
                    gdpr.$reset();
                    application.$reset();
                    this.$reset();
                }

                this.set(payload.data);

                jobData.$patch({
                    title,
                    link: href,
                    jobId,
                    isChiffre,
                    company: {
                        name: companyName,
                    },
                });
            } catch (exception) {
                logger.warning({
                    exception,
                    message: 'Payload decryption failed.',
                });
                this.reset();
            }
        },
        set(payload) {
            this.$patch({
                jobId: payload.jobId,
                isChiffre: payload.isChiffre,
                jobTitle: payload.title,
                companyName: payload.companyName,
                jobLink: payload.href,
                exists: true,
                encryptedPayload: payload.encryptedPayload,
                atsUserUuid: payload.atsUserUuid,
            });
        },
        // Give it its own action if we need to add extra steps in the future
        reset() {
            this.$reset();
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
